import {StructureColumn} from "./structureColumn";


export class StructureColumn4 {
    defaultOptions = {
        wrapperClass: 'structure__content',
        slideClass: 'card-news',
        spaceBetween: 1,
        slidesPerView: 4,
        slidesPerColumn: 1,
        slidesPerGroup: 4,
        initialSlide: 0,
        breakpoints: {
            740: {
                slidesPerView: 2,
                slidesPerColumn: 2,
                slidesPerGroup: 2
            }
        },
        navigation: {
            prevEl: '.pagination-control__navigation--prev',
            nextEl: '.pagination-control__navigation--next'
        },
        slideClassHidden: '.card-news'
    };

    slidesPerView = 4;

    structureClass = '.structure--col-4';

    constructor() {
        this.init();
    }

    init() {
        new StructureColumn(this.defaultOptions, this.slidesPerView, this.structureClass);
    }
}
